import {useAppSelector} from "@Hooks/selector/useAppSelector";
import {isEmpty} from "@Array/isEmpty";

export default function useActiveFiltersCount(): number {
    const {
        filterDuration,
        filterPrice,
        filterRating,
        filterRouteDepartureTime,
        filterRouteArrivalTime,
        filterRouteChange,
        filterDepartureTimeSlots,
        filterCompanies,
        filterCompanyScores,
        filterDepartureStation,
        filterDestinationStation,
        filterPopularFilters: {
            mTicket,
            instantConfirmation,
            webDiscount,
            direct,
        },
    } = useAppSelector((state) => state?.filter)

    const allFilters = {
        filterDuration,
        filterPrice,
        filterRating,
        filterRouteDepartureTime,
        filterRouteArrivalTime,
        filterRouteChange,
        filterDepartureTimeSlots: filterDepartureTimeSlots.night === true || filterDepartureTimeSlots.morning === true || filterDepartureTimeSlots.afternoon === true || filterDepartureTimeSlots.evening === true,
        filterCompanies: !isEmpty(filterCompanies),
        filterCompanyScores: !isEmpty(filterCompanyScores),
        filterDepartureStation: !isEmpty(filterDepartureStation),
        filterDestinationStation: !isEmpty(filterDestinationStation),
        mTicket,
        instantConfirmation,
        webDiscount,
        direct,
    }

    const activeFilters = Object.values(allFilters).filter((value) => (!!value))

    return activeFilters.length
}